import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";
import bus from '../../../../ask/eventBus';
import { getCookie } from '../../../../ask/cookiejs'
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue'
export default {
  components: { menberMenu },
  data() {
    return {
      userType: 0,
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },

      titNames: "My invoice",
      titUrls: "",

      myHeaders: {
        ['X-JWT-TOKEN']: getCookie('X-BY-EnTOKEN')
      },

      showModal: false,//弹框遮罩层

      //标题栏
      isShowBox: (JSON.parse(sessionStorage.getItem("customerInfos")).CustomerOwnerType != 2) ? 1 : 2, //显示哪个内容框，1：我的发票，2：地址库，3：产品信息库

      //我的发票
      InvoiceList: [],


      ////-------------------地址库---------------------////
      isShowAddr: 1, // 1:发件人地址库  2：收件人地址库
      //发件人地址库
      addrShipperList: [], //发件人地址库
      shipperAdd: false,
      shippertitle: '', //发件人地址库弹框标题，区分是新增还是编辑标题

      fromShipperAddr: {//发件人弹框数据
        company: '', Address_Name: '', Address_Tel: '', Address_Mail: '',
        Address_Country: 'China', Country_Key: '3c48f3d4-8f99-4721-9e88-2ff6f77b10bf', Address_Prov: '', Province_Key: '',
        Address_City: '', City_Key: '',
        Address_ZIPCode: '',
        Address_Street: '',
        RegionalType: 2,
        Address_ID: null,
        Address_IsDefault: false,
        //错误提示语
        msgCompany: '',
        msgCountry: '',
        msgContact: '',
        msgPhone: '',
        msgEmail: '',
        msgCity: '',
        msgZipCode: '',
        msgAddress: '',
      },
      chCityOptions: [],

      //收件人地址库
      addrConsigneeList: [],//收件人地址库
      consigneeAdd: false, //是否显示弹框
      consigneetitle: '', //收件人地址库弹框标题，区分是新增还是编辑标题
      fromConsigneeAddr: {//收件人弹框数据
        company: '', Address_Name: '', Address_Tel: '', Address_Mail: '',
        Address_Country: '', Country_Key: '', Address_Prov: '', Province_Key: '',
        Address_City: '', City_Key: '',
        Address_ZIPCode: '',
        Address_Street: '',
        RegionalType: 2,
        Address_ID: '',
        Address_IsDefault: false,

        //错误提示语
        msgCompany: '',
        msgCountry: '',
        msgContact: '',
        msgPhone: '',
        msgEmail: '',
        msgCity: '',
        msgZipCode: '',
        msgAddress: '',
      },
      countryOptions: [], //海外国家下拉数据
      cityOptions: [],//海外城市下来数据
      loading: false,

      ////-------------------产品库---------------------////
      productList: [], //产品信息库
      productAdd: false, //增加产品框

      //弹框内容
      fromCargoInfo: {
        title: '',
        Id: '',
        prodCommodity: '', //品名
        prodHsCode: '', //海关编码
        prodMateries: '', //材质
        prodUse: '',//用途
        prodModel: '', //型号
        prodSpeci: '', //规格
        prodBrand: '', //品牌
        prodColor: '', //颜色
        chkUnsed: false, //无牌
        IsSelected: false, //是否默认

        msgComm: '',//品名验证提示语
        msgHsCode: '', //海关编码提示语
        msgMateries: '', //材质提示语
        msgUse: '', //用途提示语
        msgModel: '', //型号提示语
        msgSpeci: '', //规格提示语
        msgBrand: '', //品牌提示语
        msgColor: '', //颜色提示语
      },
      prodDisabled: false, //产品信息点击编辑产品信息  禁止修改品名

      fileList1: [], //图片上传内容
      ImgUrl: '', //图片上传的第一个值存储，第一个值不执行删除，第二个路径值执行删除接口，删除图片      
      upLoadData: {
        PathName: 'UploadSmallImg',
        IsTempFile: false
      },//导入文件
      currentPageMy: 1,
      pageSizeMy: 20,
      totalMy: 0,
    };
  },

  created() {
    this.getInvoiceList();//我的发票列表数据
    this.getSendList();//发件人地址列表接口数据
    this.getReceivesList();//收件人地址列表接口数据
    this.getCargoInfo(); //产品信息库接口
  },
  mounted() {
    this.userType = JSON.parse(sessionStorage.getItem("customerInfos")).CustomerOwnerType;
  },
  watch: {

  },
  computed: {//计算属性周期函数

  },
  methods: {
    //标题点解切换事件
    clkMode(val) {
      this.isShowBox = val
      switch (val) {
        case 1:
          this.getInvoiceList();
          break;
        case 2:
          this.getSendList();
          this.getReceivesList();
          break;
        case 3:
          this.getCargoInfo();
          break;
      }
    },

    // //---------------------------------------------我的发票------------------------------------// //
    // 切换页码
    handleCurrentChangeMy(val) {
      this.currentPageMy = val;
      this.getInvoiceList(1);
    },
    //发票列表数据
    getInvoiceList(type = 0) {
      if (type == 0) {
        this.currentPageMy = 1;
        this.pageSizeMy = 20;
        this.totalMy = 0;
        this.InvoiceList = [];
      }
      let that = this
      that.api.param = {
        sendCompany: '',
        Page: that.currentPageMy,
        Size: that.pageSizeMy,
      }
      // that.api.url = that.$api02 + '/api/EbayCustomer/MyInvoice/QueryMyInvoiceEn';
      that.api.url = that.$api04 + '/Basics/api/MyInvoice/QueryMyInvoiceEn';
      fetch(that.api.url, that.api.param).then(function (res) {
        if (res.Results) {
          that.InvoiceList = res.Results;
          that.totalMy = res.Total;
        }
      })
    },
    //点击make new invoice
    clkMakeInvoice() {
      // window.location.href='/myInfo/CommonInvoice?ConsigneeID=0&ConsignorID=0&CusInvoiceID=0'
      this.$router.push({ path: '/myInfo/CommonInvoice', query: { ConsigneeID: 0, ConsignorID: 0, CusInvoiceID: 0 } });
    },

    //点击编辑发票
    editInvoice(ConsigneeID, ConsignorID, invoiceID) {
      window.location.href = '/myInfo/CommonInvoice?ConsigneeID=' + ConsigneeID + '&ConsignorID=' + ConsignorID + '&CusInvoiceID=' + invoiceID
    },
    //点击预览按钮
    clkPreview(invoiceID) {

      window.location.href = '/myInfo/CommonInvoicePreview?CusInvoiceID=' + invoiceID
    },


    // //---------------------------------------------收发件人地址库------------------------------------// //
    //地址库tab点击切换
    clkAddrTag(val) {
      this.isShowAddr = val
    },
    //---------------发件人地址库-----------------//
    //发件地址库接口数据
    getSendList() {
      let that = this;
      // that.api.url = that.$api02 + '/api/EbayCustomer/Addresser/List';
      that.api.url = that.$api04 + '/Basics/api/Addresser/List';
      post(that.api.url).then(function (res) {
        if (res.Results) {
          that.addrShipperList = res.Results;
        }
      })
    },
    //设为默认接口
    getIsDefault(val) {
      let that = this;
      that.api.param = {
        Address_ID: val
      }
      that.api.url = that.$api02 + '/api/EbayCustomer/Addresser/SetDefault';
      post(that.api.url, that.api.param).then(function (res) {
        if (res.Results) {
          that.fromShipperAddr.Address_IsDefault = res.Results;
          that.getSendList(); //刷新列表页面
        }
      })
    },
    //发件地址库删除按钮
    delSendBtn(val) {
      this.$confirm('Are you sure to delete this address information?', 'Delect the address', {
        customClass: 'custom-message-box', //自定义添加Class
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
        closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
        // showCancelButton:false,//去掉取消按钮
        //showClose:false,//去掉右上角的取消（X）
        // type:'warning',
        center: true
      }).then(() => {
        this.delSendData(val);
      }).catch(() => {

      });
      return false
    },
    //发件地址库删除列表数据接口
    delSendData(val) {
      let that = this;
      that.api.param = {
        Address_ID: val
      }
      that.api.url = that.$api02 + '/api/EbayCustomer/AddresserEn/Delete';
      post(that.api.url, that.api.param).then(function (res) {
        if (res.Results) {
          // that.isDefault = res.Results;
          that.getSendList(); //刷新列表页面
        }
      })
    },

    senderEditBox(item) { //发件地址编辑按钮
      this.showModal = true;
      this.shipperAdd = true;
      this.shippertitle = 'Edit address of Consignor'

      let newInfos = JSON.parse(JSON.stringify(item)) //点击编辑的时候，把数据复制一遍，避免在输入框值改动的时候，列表的值一起改动
      // this.fromShipperAddr=newInfos
      this.fromShipperAddr.company = newInfos.company
      this.fromShipperAddr.Address_Name = newInfos.Address_Name
      this.fromShipperAddr.Address_Tel = newInfos.Address_Tel
      this.fromShipperAddr.Address_Mail = newInfos.Address_Mail
      this.fromShipperAddr.Address_Country = newInfos.Address_Country
      this.fromShipperAddr.Country_Key = newInfos.Country_Key
      this.fromShipperAddr.Province_Key = newInfos.Province_Key
      this.fromShipperAddr.Address_City = newInfos.Address_City
      this.fromShipperAddr.City_Key = newInfos.City_Key
      this.fromShipperAddr.Address_ZIPCode = newInfos.Address_ZIPCode
      this.fromShipperAddr.Address_Street = newInfos.Address_Street
      this.fromShipperAddr.Address_IsDefault = newInfos.Address_IsDefault
      this.fromShipperAddr.Address_ID = newInfos.Address_ID

      this.getChinaCityInfo(this.fromShipperAddr.Address_City); //调用中国城市数据接口

    },

    //新增发件人
    senderAddInfo() {
      this.showModal = true;
      this.shipperAdd = true

      //发件人地址库清空数据
      this.fromShipperAddr.company = '';
      this.fromShipperAddr.Address_Name = '';
      this.fromShipperAddr.Address_Tel = '';
      this.fromShipperAddr.Address_Mail = '';
      this.fromShipperAddr.Address_Country = 'China';
      this.fromShipperAddr.Country_Key = '3c48f3d4-8f99-4721-9e88-2ff6f77b10bf';
      this.fromShipperAddr.Address_Prov = '';
      this.fromShipperAddr.Province_Key = '';
      this.fromShipperAddr.Address_City = '';
      this.fromShipperAddr.City_Key = '';
      this.fromShipperAddr.Address_ZIPCode = '';
      this.fromShipperAddr.Address_Street = '';
      this.fromShipperAddr.Address_ID = '';
      this.fromShipperAddr.Address_IsDefault = false;

      this.fromShipperAddr.msgCompany = ''; //提示输入位置
      this.fromShipperAddr.msgCountry = '';
      this.fromShipperAddr.msgContact = '';
      this.fromShipperAddr.msgPhone = '';
      this.fromShipperAddr.msgEmail = '';
      this.fromShipperAddr.msgCity = '';
      this.fromShipperAddr.msgZipCode = '';
      this.fromShipperAddr.msgCityKey = '';
      this.fromShipperAddr.msgAddress = '';

      this.shippertitle = 'Add new address of Consignor'
    },

    //中国城市数据接口
    getChinaCityInfo(query) {
      let that = this
      that.api.param = {
        "CityName": query,
        "Type": 'Ch', //Ch:查中国城市数据  En：查海外城市数据
        "Take": 50,
      }
      // that.api.url = that.$api02 + '/api/EbayCustomer/City/GetStartCityQuery'
      that.api.url = that.$api04 + '/Basics/api/SysRegion/GetStartCityQuery'
      post(that.api.url, that.api.param).then(function (res) {
        that.chCityOptions = res.Results
        that.loading = false;
      })
    },

    //发件人城市数据
    shipperRemoteMethod(query) {
      if (query != '') {
        this.loading = true;
        this.getChinaCityInfo(query);
      } else {
        this.chCityOptions = [];
      }
    },
    //中国城市值改变
    changeChCityKey(val) {
      if (!this.fromShipperAddr.City_Key) {
        this.fromShipperAddr.msgCity = 'Required'
        return false
      } else {
        if (this.chCityOptions) {
          this.chCityOptions.forEach(e => {
            if (e.CityKey == this.fromShipperAddr.City_Key) {
              this.fromShipperAddr.Address_City = e.CityNameEn
              this.fromShipperAddr.Address_Prov = e.Province_NameEn
              this.fromShipperAddr.Province_Key = e.ProvinceKey
            }
          })
        }
        this.fromShipperAddr.msgCity = ''
        return true
      }
    },
    //发件人地址编辑接口
    editSendItem() {
      let that = this
      that.api.param = {
        Address_ID: that.fromShipperAddr.Address_ID,
        Address_Name: that.fromShipperAddr.Address_Name,
        Address_Mail: that.fromShipperAddr.Address_Mail,
        Address_Country: that.fromShipperAddr.Address_Country,
        Address_Prov: that.fromShipperAddr.Address_Prov,
        Address_City: that.fromShipperAddr.Address_City,
        Address_Street: that.fromShipperAddr.Address_Street,
        Address_Tel: that.fromShipperAddr.Address_Tel,
        Address_ZIPCode: that.fromShipperAddr.Address_ZIPCode,
        Country_Key: that.fromShipperAddr.Country_Key,
        Province_Key: that.fromShipperAddr.Province_Key,
        City_Key: that.fromShipperAddr.City_Key,
        RegionalType: that.fromShipperAddr.RegionalType,
        company: that.fromShipperAddr.company,
      }

      that.api.url = that.$api02 + '/api/EbayCustomer/AddresserEn/Update';
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.getSendList(); //收件人地址列表
          that.showModal = false;
          that.shipperAdd = false;
        } else if (res.IsOK == false) {


          that.$confirm('failed', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            // showCancelButton:false,//去掉取消按钮
            //showClose:false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {

          }).catch(() => { });
          return false
        }
      })
    },
    //发件人地址新增接口
    addSendItem() {
      let that = this
      that.api.param = {
        Address_ID: that.fromShipperAddr.Address_ID,
        Address_Name: that.fromShipperAddr.Address_Name,
        Address_Mail: that.fromShipperAddr.Address_Mail,
        Address_Country: that.fromShipperAddr.Address_Country,
        Address_Prov: that.fromShipperAddr.Address_Prov,
        Address_City: that.fromShipperAddr.Address_City,
        Address_Street: that.fromShipperAddr.Address_Street,
        Address_Tel: that.fromShipperAddr.Address_Tel,
        Address_ZIPCode: that.fromShipperAddr.Address_ZIPCode,
        Country_Key: that.fromShipperAddr.Country_Key,
        Province_Key: that.fromShipperAddr.Province_Key,
        City_Key: that.fromShipperAddr.City_Key,
        RegionalType: that.fromShipperAddr.RegionalType,
        company: that.fromShipperAddr.company,
      }
      that.api.url = that.$api02 + '/api/EbayCustomer/AddresserEn/Add';
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.showModal = false;
          that.shipperAdd = false;
          that.getSendList();
        } else if (res.IsOK == false) {
          if (res.ErrorCode == 'C0013') {
            that.fromShipperAddr.msgCompany = 'The shipper company already exists!'
          } else {
            that.$confirm('failed', '', {
              customClass: 'custom-message-box', //自定义添加Class
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
              closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
              // showCancelButton:false,//去掉取消按钮
              //showClose:false,//去掉右上角的取消（X）
              // type: 'warning',
              center: true
            }).then(() => {

            }).catch(() => { });
            return false
          }
        }

      })
    },

    //发件人地址库弹框保存按钮
    shipperSaveBtn() {
      if (
        !this.blurshipCompany() || !this.blurshipContact() || !this.blurshipPhone() || !this.blurshipEmail() || !this.changeChCityKey() ||
        !this.blurshipZipCode() ||
        !this.blurshipAddr()
      ) {
        return false
      }
      //console.log('Address_ID  '  + this.fromConsigneeAddr.Address_ID)
      if (this.fromShipperAddr.Address_ID) {
        this.editSendItem();
      } else if (!this.fromShipperAddr.Address_ID) {
        this.addSendItem();
      }
    },

    //发件人input验证方法
    blurshipCompany() {//公司名称
      let val = $.trim(this.fromShipperAddr.company)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (!val) {
        this.fromShipperAddr.msgCompany = 'Required'
      } else if (val.length > 200) {
        this.fromShipperAddr.msgCompany = 'Maximum is 200 characters'
        return false
      } else if (!regTest.test(val)) {
        this.fromShipperAddr.msgCompany = 'English only'
        return false
      } else {
        this.fromShipperAddr.msgCompany = ''
        return true
      }
    },
    blurshipContact() {//联系人
      let val = $.trim(this.fromShipperAddr.Address_Name)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (!val) {
        this.fromShipperAddr.msgContact = 'Required'
      } else if (val.length > 100) {
        this.fromShipperAddr.msgContact = 'Maximum is 100 characters'
        return false
      } else if (!regTest.test(val)) {
        this.fromShipperAddr.msgContact = 'English only'
        return false
      } else {
        this.fromShipperAddr.msgContact = ''
        return true
      }
    },
    blurshipPhone() {//联系电话
      let val = $.trim(this.fromShipperAddr.Address_Tel)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (!val) {
        this.fromShipperAddr.msgPhone = 'Required'
      } else if (val.length > 50) {
        this.fromShipperAddr.msgPhone = 'Maximum is 50 characters'
        return false
      } else if (!regTest.test(val)) {
        this.fromShipperAddr.msgPhone = 'English only'
        return false
      } else {
        this.fromShipperAddr.msgPhone = ''
        return true
      }
    },
    blurshipEmail() {//联系邮箱
      let val = $.trim(this.fromShipperAddr.Address_Mail)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (val && val.length > 50) {
        this.fromShipperAddr.msgEmail = 'Maximum is 50 characters'
        return false
      } else if (val && !regTest.test(val)) {
        this.fromShipperAddr.msgEmail = 'English only'
        return false
      } else {
        this.fromShipperAddr.msgEmail = ''
        return true
      }
    },
    blurshipZipCode() { //邮编
      let val = $.trim(this.fromShipperAddr.Address_ZIPCode)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (val.length > 50) {
        this.fromShipperAddr.msgZipCode = 'Maximum is 50 characters'
        return false
      } else if (val && !regTest.test(val)) {
        this.fromShipperAddr.msgZipCode = 'English only'
        return false
      } else {
        this.fromShipperAddr.msgZipCode = ''
        return true
      }
    },
    blurshipAddr() { //地址
      let val = $.trim(this.fromShipperAddr.Address_Street)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (!val) {
        this.fromShipperAddr.msgAddress = 'Required'
      } else if (val.length > 500) {
        this.fromShipperAddr.msgAddress = 'Maximum is 500 characters'
        return false
      } else if (!regTest.test(val)) {
        this.fromShipperAddr.msgAddress = 'English only'
        return false
      } else {
        this.fromShipperAddr.msgAddress = ''
        return true
      }
    },

    //---------------收件人地址库-----------------//
    //收件地址列表接口数据
    getReceivesList() {
      let that = this;
      // that.api.url = that.$api02 + '/api/EbayCustomer/Addressee/List';
      that.api.url = that.$api04 + "/Basics/api/Addressee/List";
      post(that.api.url, {
        Page: 1,
        Size: 99999
      }).then(function (res) {
        that.addrConsigneeList = res.Results;
      })
    },
    //设为默认
    setConsigDefault(val) {
      let that = this;
      that.api.param = {
        Address_ID: val
      }
      that.api.url = that.$api02 + '/api/EbayCustomer/Addressee/SetDefault';
      post(that.api.url, that.api.param).then(function (res) {
        if (res.Results) {
          that.fromConsigneeAddr.Address_IsDefault = res.Results;
          that.getReceivesList(); //刷新列表页面
        }

      })
    },
    //编辑按钮
    receiptEditBox(item, val) { //收件地址编辑按钮
      this.showModal = true;
      this.consigneeAdd = true;
      this.consigneetitle = 'Edit address of consignee'
      let newInfos = JSON.parse(JSON.stringify(item))

      //this.fromConsigneeAddr=newInfo
      this.fromConsigneeAddr.company = newInfos.company
      this.fromConsigneeAddr.Address_Name = newInfos.Address_Name
      this.fromConsigneeAddr.Address_Tel = newInfos.Address_Tel
      this.fromConsigneeAddr.Address_Mail = newInfos.Address_Mail
      this.fromConsigneeAddr.Address_Country = newInfos.Address_Country
      this.fromConsigneeAddr.Country_Key = newInfos.Country_Key
      this.fromConsigneeAddr.Province_Key = newInfos.Province_Key
      this.fromConsigneeAddr.Address_City = newInfos.Address_City
      this.fromConsigneeAddr.City_Key = newInfos.City_Key
      this.fromConsigneeAddr.Address_ZIPCode = newInfos.Address_ZIPCode
      this.fromConsigneeAddr.Address_Street = newInfos.Address_Street
      this.fromConsigneeAddr.Address_IsDefault = newInfos.Address_IsDefault
      this.fromConsigneeAddr.Address_ID = newInfos.Address_ID

      this.getCountryInfo(); //调用海外国家接口
    },
    //删除按钮
    delReceivesList(val) { //收件人删除按钮
      this.$confirm('Are you sure to delete this address information?', 'Delect the address', {
        customClass: 'custom-message-box', //自定义添加Class
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
        closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
        // showCancelButton:false,//去掉取消按钮
        //showClose:false,//去掉右上角的取消（X）
        // type: 'warning',
        center: true
      }).then(() => {
        this.receivesDelPort(val);
      }).catch(() => { });
      return false
    },
    receivesDelPort(val) { //删除接口
      let that = this;
      that.api.param = {
        Address_ID: val,
      }
      that.api.url = that.$api02 + '/api/EbayCustomer/AddresseeEn/Delete';
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.getReceivesList();
        } else {
          that.$confirm('Delete failed!', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            //showCancelButton:false,//去掉取消按钮
            //showClose:false,//去掉右上角的取消（X）
            //type: 'warning',
            center: true
          }).then(() => {
            //this.receivesDelPort(val);
          }).catch(() => { });
          return false
        }
      })
    },

    //---收件人弹框方法-----//
    //点击新增收件人按钮
    receiptAddInfo() {
      this.showModal = true;
      this.consigneeAdd = true;

      //收件人地址库清空提示数据
      this.fromConsigneeAddr.company = '',
        this.fromConsigneeAddr.Address_Name = '',
        this.fromConsigneeAddr.Address_Tel = '',
        this.fromConsigneeAddr.Address_Mail = '',
        this.fromConsigneeAddr.Address_Country = '',
        this.fromConsigneeAddr.Country_Key = '',
        this.fromConsigneeAddr.Address_City = '',
        this.fromConsigneeAddr.City_Key = '',
        this.fromConsigneeAddr.Address_ZIPCode = '',
        this.fromConsigneeAddr.Address_Street = '',
        this.fromConsigneeAddr.Address_ID = ''

      this.fromConsigneeAddr.msgCompany = ''; //提示输入位置
      this.fromConsigneeAddr.msgCountry = '';
      this.fromConsigneeAddr.msgContact = '';
      this.fromConsigneeAddr.msgPhone = '';
      this.fromConsigneeAddr.msgEmail = '';
      this.fromConsigneeAddr.msgCity = '';
      this.fromConsigneeAddr.msgZipCode = '';
      this.fromConsigneeAddr.msgCityKey = '';
      this.fromConsigneeAddr.msgAddress = '';

      this.consigneetitle = 'Add new address of consignee'
      this.getCountryInfo(); //调用海外国家数据接口
    },

    //海外国家数据接口
    getCountryInfo() {
      let that = this
      that.api.param = {
      }
      // that.api.url = that.$api02 + '/api/EbayCustomer/ForeignCity/QueryForeignCountry'
      that.api.url = that.$api04 + "/Basics/api/ForeignCity/QueryForeignCountry";
      fetch(that.api.url, that.api.param).then(function (res) {
        that.countryOptions = res.Results
      })
    },
    // 国家值改变 
    changeCountryKey(item) {
      this.blurCountry(); //调用国家验证方法
      //国家值改变清空城市下拉数据和城市值
      this.cityOptions = []
      this.fromConsigneeAddr.Address_City = ''
    },
    //海外城市数据接口
    getCityInfo(query) {
      let that = this
      that.api.param = {
        countryKey: that.fromConsigneeAddr.Country_Key,
        //postCode:code,
        cityName: query,
        take: 100,
      }
      that.api.url = that.$api02 + '/api/EbayCustomer/ForeignCity/QueryForeignCtiy'
      fetch(that.api.url, that.api.param).then(function (res) {
        that.cityOptions = res.Results
        that.loading = false;
      })
    },

    //收件人城市方法
    remoteMethod(query) {
      if (query != '') {
        this.loading = true;
        this.getCityInfo(query);
      } else {
        this.cityOptions = [];
      }
    },

    chaneCityKey() { //城市值改变

      let val = $.trim(this.fromConsigneeAddr.Address_City)
      let regTest = /^[^\u4E00-\u9FA5]+$/

      if (!val) {
        this.fromConsigneeAddr.msgCity = 'Required'
        //this.cityOptions=[]
        return false
      }

      if (val && val.length > 100) {
        this.fromConsigneeAddr.msgCity = 'Maximum is 100 characters'
        return false
      } else if (val && !regTest.test(val)) {
        this.fromConsigneeAddr.msgCity = 'English only'
        return false
      } else {
        this.fromConsigneeAddr.msgCity = ''
        return true
      }
    },

    //点击保存
    prosaveBtn() {
      if (!this.blurConsigCompany() || !this.blurConsigContact() || !this.blurConsigPhone() || !this.blurConsigEmail() || !this.blurCountry() ||
        !this.chaneCityKey() || !this.blurConsigZipCode() || !this.blurConsigAddr()
      ) {
        return false
      }
      //console.log('this.fromConsigneeAddr.Address_ID  '  + this.fromConsigneeAddr.Address_ID)
      if (this.fromConsigneeAddr.Address_ID) {
        this.editRecipientItem();
      } else if (!this.fromConsigneeAddr.Address_ID) {
        this.addRecipientItem();
      }
    },

    editRecipientItem() { //收件人地址编辑接口
      let that = this
      that.api.param = {
        Address_ID: that.fromConsigneeAddr.Address_ID,
        Address_Name: that.fromConsigneeAddr.Address_Name,
        Address_Mail: that.fromConsigneeAddr.Address_Mail,
        //Address_Country:that.fromConsigneeAddr.Address_Country,
        Address_Prov: that.fromConsigneeAddr.Address_Prov,
        Address_City: that.fromConsigneeAddr.Address_City,
        Address_IsDefault: that.fromConsigneeAddr.isDefault,
        Address_Street: that.fromConsigneeAddr.Address_Street,
        Address_Tel: that.fromConsigneeAddr.Address_Tel,
        Address_ZIPCode: that.fromConsigneeAddr.Address_ZIPCode,
        Country_Key: that.fromConsigneeAddr.Country_Key,
        Province_Key: that.fromConsigneeAddr.Province_Key,
        City_Key: that.fromConsigneeAddr.City_Key,
        RegionalType: that.fromConsigneeAddr.RegionalType,
        company: that.fromConsigneeAddr.company,
      }

      that.countryOptions.forEach(e => {
        if (that.fromConsigneeAddr.Country_Key == e.CountryKey) {
          that.api.param['Address_Country'] = e.NameEn
        }
      })


      that.api.url = that.$api02 + '/api/EbayCustomer/AddresseeEn/Update';
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.getReceivesList(); //收件人地址列表
          that.showModal = false;
          that.consigneeAdd = false;
        } else if (res.IsOK == false) {
          that.$confirm('failed', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            // showCancelButton:false,//去掉取消按钮
            //showClose:false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {

          }).catch(() => { });
          return false
        }
      })
    },
    addRecipientItem() { //收件人地址新增接口
      let that = this
      that.api.param = {
        Address_ID: that.fromConsigneeAddr.Address_ID,
        Address_Name: that.fromConsigneeAddr.Address_Name,
        Address_Mail: that.fromConsigneeAddr.Address_Mail,
        // Address_Country:that.fromConsigneeAddr.Address_Country,
        Address_Prov: that.fromConsigneeAddr.Address_Prov,
        Address_City: that.fromConsigneeAddr.Address_City,
        Address_Street: that.fromConsigneeAddr.Address_Street,
        Address_Tel: that.fromConsigneeAddr.Address_Tel,
        Address_ZIPCode: that.fromConsigneeAddr.Address_ZIPCode,
        Country_Key: that.fromConsigneeAddr.Country_Key,
        Province_Key: that.fromConsigneeAddr.Province_Key,
        City_Key: that.fromConsigneeAddr.City_Key,
        RegionalType: that.fromConsigneeAddr.RegionalType,
        company: that.fromConsigneeAddr.company,
        Address_IsDefault: that.fromConsigneeAddr.isDefault,
      }
      that.countryOptions.forEach(e => {
        if (that.fromConsigneeAddr.Country_Key == e.CountryKey) {
          that.api.param['Address_Country'] = e.NameEn
        }
      })
      //countryOptions

      that.api.url = that.$api02 + '/api/EbayCustomer/AddresseeEn/Add';
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.showModal = false;
          that.consigneeAdd = false;
          that.getReceivesList();
        } else if (res.IsOK == false) {
          if (res.ErrorCode == 'C0013') {
            that.fromConsigneeAddr.msgCompany = 'The consignee company already exists!'
          } else {
            that.$confirm('failed', '', {
              customClass: 'custom-message-box', //自定义添加Class
              confirmButtonText: 'confirm',
              cancelButtonText: 'cancel',
              cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
              closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
              // showCancelButton:false,//去掉取消按钮
              //showClose:false,//去掉右上角的取消（X）
              // type: 'warning',
              center: true
            }).then(() => {

            }).catch(() => { });
            return false
          }


        }
      })
    },

    //发件人input验证方法
    blurConsigCompany() {//公司名称
      let val = $.trim(this.fromConsigneeAddr.company)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (!val) {
        this.fromConsigneeAddr.msgCompany = 'Required'
      } else if (val.length > 200) {
        this.fromConsigneeAddr.msgCompany = 'Maximum is 200 characters'
        return false
      } else if (!regTest.test(val)) {
        this.fromConsigneeAddr.msgCompany = 'English only'
        return false
      } else {
        this.fromConsigneeAddr.msgCompany = ''
        return true
      }
    },
    blurConsigContact() {//联系人
      let val = $.trim(this.fromConsigneeAddr.Address_Name)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (!val) {
        this.fromConsigneeAddr.msgContact = 'Required'
      } else if (val.length > 100) {
        this.fromConsigneeAddr.msgContact = 'Maximum is 100 characters'
        return false
      } else if (!regTest.test(val)) {
        this.fromConsigneeAddr.msgContact = 'English only'
        return false
      } else {
        this.fromConsigneeAddr.msgContact = ''
        return true
      }
    },

    blurConsigPhone() {//联系电话
      let val = $.trim(this.fromConsigneeAddr.Address_Tel)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (!val) {
        this.fromConsigneeAddr.msgPhone = 'Required'
      } else if (val.length > 50) {
        this.fromConsigneeAddr.msgPhone = 'Maximum is 50 characters'
        return false
      } else if (!regTest.test(val)) {
        this.fromConsigneeAddr.msgPhone = 'English only'
        return false
      } else {
        this.fromConsigneeAddr.msgPhone = ''
        return true
      }
    },
    blurConsigEmail() {//联系邮箱
      let val = $.trim(this.fromConsigneeAddr.Address_Mail)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (val && val.length > 50) {
        this.fromConsigneeAddr.msgEmail = 'Maximum is 50 characters'
        return false
      } else if (val && !regTest.test(val)) {
        this.fromConsigneeAddr.msgEmail = 'English only'
        return false
      } else {
        this.fromConsigneeAddr.msgEmail = ''
        return true
      }
    },

    blurCountry() {//国家下拉
      let val = $.trim(this.fromConsigneeAddr.Country_Key)
      if (!val) {
        this.fromConsigneeAddr.msgCountry = 'Required'
        return false
      } else {
        this.fromConsigneeAddr.msgCountry = ''
        return true
      }
    },
    blurConsigZipCode() { //邮编
      let val = $.trim(this.fromConsigneeAddr.Address_ZIPCode)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (!val) {
        this.fromConsigneeAddr.msgZipCode = 'Required'
      } else if (val.length > 50) {
        this.fromConsigneeAddr.msgZipCode = 'Maximum is 50 characters'
        return false
      } else if (!regTest.test(val)) {
        this.fromConsigneeAddr.msgZipCode = 'English only'
        return false
      } else {
        this.fromConsigneeAddr.msgZipCode = ''
        return true
      }
    },
    blurConsigAddr() { //地址
      let val = $.trim(this.fromConsigneeAddr.Address_Street)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (!val) {
        this.fromConsigneeAddr.msgAddress = 'Required'
      } else if (val.length > 500) {
        this.fromConsigneeAddr.msgAddress = 'Maximum is 500 characters'
        return false
      } else if (!regTest.test(val)) {
        this.fromConsigneeAddr.msgAddress = 'English only'
        return false
      } else {
        this.fromConsigneeAddr.msgAddress = ''
        return true
      }
    },


    // //------------------------------------------产品信息库-------------------------------------------// //
    //产品信息库列表接口
    getCargoInfo() {
      let that = this
      that.api.param = {}
      // that.api.url = that.$api02 + '/api/EbayCustomer/BasProduct/Get';
      that.api.url = that.$api04 + "/Basics/api/BasProduct/Get";
      fetch(that.api.url, that.api.param).then(function (res) {
        res.Results.forEach(item => {
          that.$set(item, 'Id', item.ID);
        })
        that.productList = res.Results
        // console.log('sd ' +  JSON.stringify(that.productList))
        // if(res.Results.length > 0){
        //   that.productList=res.Results
        //   console.log('sd ' +  JSON.stringify(that.productList))
        // }
      })
    },
    //设为默认
    setDefault(val) {
      let that = this
      that.api.url = that.$api02 + '/api/EbayCustomer/BasProduct/SetDefault/' + val;
      post(that.api.url).then(function (res) {
        if (res.Results == true) {
          that.getCargoInfo();
        } else {

        }
      })
    },
    //编辑按钮
    cargoEdit(item) {
      this.prodDisabled = true; //禁止修改产品信息中品名
      this.showModal = true;
      this.productAdd = true;
      this.fromCargoInfo.title = 'Edit product'

      let newInfo = JSON.parse(JSON.stringify(item))
      this.fromCargoInfo.Id = newInfo.Id
      this.fromCargoInfo.prodCommodity = newInfo.EnglishName
      this.fromCargoInfo.prodHsCode = newInfo.CustomsCode
      this.fromCargoInfo.prodMateries = newInfo.Material
      this.fromCargoInfo.prodUse = newInfo.Purpose
      this.fromCargoInfo.prodModel = newInfo.Model
      this.fromCargoInfo.prodSpeci = newInfo.Spec
      this.fromCargoInfo.prodBrand = newInfo.Brand
      this.fromCargoInfo.prodColor = newInfo.Color
      this.fromCargoInfo.IsSelected = newInfo.IsSelected

      if (this.fromCargoInfo.prodBrand == 'unlicensed') {
        this.fromCargoInfo.chkUnsed = true
      } else {
        this.fromCargoInfo.chkUnsed = false
      }
      //图片格式赋值
      this.fileList1 = []
      if (newInfo.PicPath) {
        this.fileList1.push({ PicPath: newInfo.PicPath, PicOrgName: newInfo.PicOrgName })
      }
      this.ImgUrl = item.PicPath  //保存值
    },
    //新增产品信息弹框
    clkAddProd() {
      this.prodDisabled = false, //启用产品信息库品名新增
        this.showModal = true,
        this.productAdd = true
      this.fromCargoInfo.title = 'Add product'
      //清楚弹框数据
      this.fromCargoInfo.Id = ''
      this.fromCargoInfo.prodCommodity = ''
      this.fromCargoInfo.prodHsCode = ''
      this.fromCargoInfo.prodMateries = ''
      this.fromCargoInfo.prodUse = ''
      this.fromCargoInfo.prodModel = ''
      this.fromCargoInfo.prodSpeci = ''
      this.fromCargoInfo.prodBrand = ''
      this.fromCargoInfo.prodColor = ''
      this.fromCargoInfo.IsSelected = false
      this.fromCargoInfo.chkUnsed = false

      this.fromCargoInfo.msgComm = ''
      this.fromCargoInfo.msgHsCode = ''
      this.fromCargoInfo.msgMateries = ''
      this.fromCargoInfo.msgUse = ''
      this.fromCargoInfo.msgModel = ''
      this.fromCargoInfo.msgSpeci = ''
      this.fromCargoInfo.msgBrand = ''
      this.fromCargoInfo.msgColor = ''

      this.fileList1 = []; //清楚图片列表信息
    },
    //新增产品库接口
    addPortInfo() {
      let that = this
      that.api.param = {
        // "Id": that.fromCargoInfo.Id,
        "EnglishName": that.fromCargoInfo.prodCommodity,
        "Material": that.fromCargoInfo.prodMateries,
        "CustomsCode": that.fromCargoInfo.prodHsCode,
        "Purpose": that.fromCargoInfo.prodUse,
        "Spec": that.fromCargoInfo.prodSpeci,
        "Color": that.fromCargoInfo.prodColor,
        "IsSelected": false,
        "Model": that.fromCargoInfo.prodModel,
        "Brand": that.fromCargoInfo.prodBrand,
      }
      that.fileList1.forEach(e => {
        that.api.param['PicOrgName'] = e.PicOrgName
        that.api.param['PicPath'] = e.PicPath
      })
      // that.api.url = that.$api02 + '/api/EbayCustomer/BasProduct/Post';
      that.api.url = that.$api04 + '/Basics/api/BasProduct/Post';
      post(that.api.url, that.api.param).then(function (res) {
        if (res.Results == true) {
          that.showModal = false;
          that.productAdd = false;
          that.getCargoInfo();//编辑修改成功后，更新列表页面
        } else {
          if (res.ErrorCode == 'S0001') {
            that.fromCargoInfo.msgComm = 'The commodity already exists!'
          }
        }
      })
    },
    //编辑产品库接口
    editPortInfo() {
      let that = this
      that.api.param = {
        "Id": that.fromCargoInfo.Id,
        "EnglishName": that.fromCargoInfo.prodCommodity,
        "Material": that.fromCargoInfo.prodMateries,
        "CustomsCode": that.fromCargoInfo.prodHsCode,
        "Purpose": that.fromCargoInfo.prodUse,
        "Spec": that.fromCargoInfo.prodSpeci,
        "Color": that.fromCargoInfo.prodColor,
        "IsSelected": that.fromCargoInfo.IsSelected,
        "Model": that.fromCargoInfo.prodModel,
        "Brand": that.fromCargoInfo.prodBrand,
      }
      that.fileList1.forEach(e => {
        that.api.param['PicOrgName'] = e.PicOrgName
        that.api.param['PicPath'] = e.PicPath
      })
      that.api.url = that.$api02 + '/api/EbayCustomer/BasProduct/Put';
      post(that.api.url, that.api.param).then(function (res) {
        if (res.Results == true) {
          that.showModal = false;
          that.productAdd = false;
          that.getCargoInfo();//编辑修改成功后，更新列表页面
        } else {
          that.$confirm('failed', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            // showCancelButton:false,//去掉取消按钮
            // showClose:false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {
            //this.delAPIData(val);
          }).catch(() => {

          });
          return false
        }
      })
    },
    //勾选无牌的时候做的处理
    unlicensed(val) {
      if (val) {
        this.fromCargoInfo.prodBrand = 'unlicensed'
      } else {
        this.fromCargoInfo.prodBrand = ''
      }
      this.changeBrand(this.fromCargoInfo.prodBrand);
    },
    changeBrand(val) {
      if (!val) {
        this.fromCargoInfo.chkUnsed = false
      }
      this.blurBrand()
    },
    //删除
    delCargoItem(val) {
      this.$confirm('Are you sure to delete this product?', 'Delect the product', {
        customClass: 'custom-message-box', //自定义添加Class
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
        closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
        // showCancelButton:false,//去掉取消按钮
        // showClose:false,//去掉右上角的取消（X）
        // type: 'warning',
        center: true
      }).then(() => {
        this.delAPIData(val);
      }).catch(() => {

      });
      return false
    },
    delAPIData(val) {
      let that = this
      that.api.param = {
        id: val
      }
      that.api.url = that.$api02 + '/api/EbayCustomer/BasProduct/Delete/';
      post(that.api.url, that.api.param).then(function (res) {
        if (res.Results == true) {
          that.getCargoInfo();

        } else {
          that.$confirm('Delete failed!', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            // showCancelButton:false,//去掉取消按钮
            // showClose:false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {
            //this.delAPIData(val);
          }).catch(() => {

          });
          return false
        }
      })
    },

    //上传图片
    beforeAvatarUpload(file, fileList) {  //上传文件之前做验证
      // const extension =' .png, .jpg, .jpeg, '
      const extension = ' .png, .jpg, .jpeg, .bmp, .gif, '
      var fileName = file.name;
      var ext = fileName.substring(fileName.lastIndexOf('.'), fileName.length) + ", ";

      if (extension.indexOf(ext) == -1) {
        this.$confirm('The imported file can only be in ：' + extension + 'format!', '', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          type: 'warning',
          center: true
        })
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 0.5
      const isLtZeroM = file.size / 1024 / 1024 > 0
      if (!isLt2M) {
        this.$confirm('Upload file size is over 500kb!！', '', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          type: 'warning',
          center: true
        })
        return false;
      }
      if (!isLtZeroM) {
        this.$confirm('The file size is 0kb, please re-upload!', '', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          showCancelButton: false,//去掉取消按钮
          showClose: false,//去掉右上角的取消（X）
          type: 'warning',
          center: true
        })
        return false;
      }
      return true
    },
    handleAvatarSuccess(file, fileList) { //文件上传成功方法
      if (file.Results.UploadPath) {
        this.fileList1.push({ PicPath: file.Results.UploadPath, PicOrgName: fileList.name })
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning('Can only upload one image！')
    },
    removeTodo(item, index) { //删除图片
      //console.log('item   '+ JSON.stringify(item))
      if (this.ImgUrl != item.PicPath) {
        this.delFileImg(item.PicPath); //删除接口
      } else {
        this.fileList1.splice(index, 1);
      }
    },
    //图片删除方法
    delFileImg(val) {
      //this.fileList1.splice(index, 1);
      let that = this
      that.api.param = {
        UploadPath: val,
      }
      // that.api.url = that.$api03 + '/api/TradeCustomer/FileUpload/DeleteFile'
      that.api.url = that.$api04 + '/File/api/FileHandle/DeleteFile'
      post(that.api.url, that.api.param).then(function (res) {
        that.fileList1 = []
      })
    },

    //----弹框总方法--------//
    getClose() { //弹框关闭
      this.showModal = false,
        this.productAdd = false //产品新增弹框
      this.consigneeAdd = false //收件人地址库弹框
      this.shipperAdd = false //发件人地址库弹框,

      //发件人地址库清空数据
      this.fromShipperAddr.company = '';
      this.fromShipperAddr.Address_Name = '';
      this.fromShipperAddr.Address_Tel = '';
      this.fromShipperAddr.Address_Mail = '';
      this.fromShipperAddr.Address_Country = 'China';
      this.fromShipperAddr.Country_Key = '3c48f3d4-8f99-4721-9e88-2ff6f77b10bf';
      this.fromShipperAddr.Address_Prov = '';
      this.fromShipperAddr.Province_Key = '';
      this.fromShipperAddr.Address_City = '';
      this.fromShipperAddr.City_Key = '';
      this.fromShipperAddr.Address_ZIPCode = '';
      this.fromShipperAddr.Address_Street = '';
      this.fromShipperAddr.Address_ID = '';
      this.fromShipperAddr.Address_IsDefault = false;

      this.fromShipperAddr.msgCompany = ''; //提示输入位置
      this.fromShipperAddr.msgCountry = '';
      this.fromShipperAddr.msgContact = '';
      this.fromShipperAddr.msgPhone = '';
      this.fromShipperAddr.msgEmail = '';
      this.fromShipperAddr.msgCity = '';
      this.fromShipperAddr.msgZipCode = '';
      this.fromShipperAddr.msgCityKey = '';
      this.fromShipperAddr.msgAddress = '';

      //收件人地址库清空提示数据
      this.fromConsigneeAddr.company = '',
        this.fromConsigneeAddr.Address_Name = '',
        this.fromConsigneeAddr.Address_Tel = '',
        this.fromConsigneeAddr.Address_Mail = '',
        this.fromConsigneeAddr.Address_Country = '',
        this.fromConsigneeAddr.Country_Key = '',
        this.fromConsigneeAddr.Address_City = '',
        this.fromConsigneeAddr.City_Key = '',
        this.fromConsigneeAddr.Address_ZIPCode = '',
        this.fromConsigneeAddr.Address_Street = '',

        this.fromConsigneeAddr.msgCompany = ''; //提示输入位置
      this.fromConsigneeAddr.msgCountry = '';
      this.fromConsigneeAddr.msgContact = '';
      this.fromConsigneeAddr.msgPhone = '';
      this.fromConsigneeAddr.msgEmail = '';
      this.fromConsigneeAddr.msgCity = '';
      this.fromConsigneeAddr.msgZipCode = '';
      this.fromConsigneeAddr.msgCityKey = '';
      this.fromConsigneeAddr.msgAddress = '';

      //产品信息库清空提示数据
      this.fromCargoInfo.msgComm = ''
      this.fromCargoInfo.msgHsCode = ''
      this.fromCargoInfo.msgMateries = ''
      this.fromCargoInfo.msgUse = ''
      this.fromCargoInfo.msgSpeci = ''
      this.fromCargoInfo.msgModel = ''
      this.fromCargoInfo.msgBrand = ''
      this.fromCargoInfo.msgColor = ''
    },
    //产品信息库验证 //input 验证
    blurReq() { //品名验证
      let val = $.trim(this.fromCargoInfo.prodCommodity)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (!val) {
        this.fromCargoInfo.msgComm = 'Required'
      } else if (val.length > 50) {
        this.fromCargoInfo.msgComm = 'Maximum is 50 characters'
        return false
      } else if (!regTest.test(val)) {
        this.fromCargoInfo.msgComm = 'English only'
        return false
      } else {
        this.fromCargoInfo.msgComm = ''
        return true
      }
    },
    blurCusCode() { //海关编码验证
      let val = $.trim(this.fromCargoInfo.prodHsCode)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (val && val.length > 50) {
        this.fromCargoInfo.msgHsCode = 'Maximum is 50 characters'
        return false
      } else if (val && !regTest.test(val)) {
        this.fromCargoInfo.msgHsCode = 'English only'
        return false
      } else {
        this.fromCargoInfo.msgHsCode = ''
        return true
      }

    },
    blurMaterial() { //材质验证
      let val = $.trim(this.fromCargoInfo.prodMateries)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (val && val.length > 50) {
        this.fromCargoInfo.msgMateries = 'Maximum is 50 characters'
        return false
      } else if (val && !regTest.test(val)) {
        this.fromCargoInfo.msgMateries = 'English only'
        return false
      } else {
        this.fromCargoInfo.msgMateries = ''
        return true
      }
    },
    blurUse() { //用途验证
      let val = $.trim(this.fromCargoInfo.prodUse)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (val && val.length > 50) {
        this.fromCargoInfo.msgUse = 'Maximum is 50 characters'
        return false
      } else if (val && !regTest.test(val)) {
        this.fromCargoInfo.msgUse = 'English only'
        return false
      } else {
        this.fromCargoInfo.msgUse = ''
        return true
      }
    },
    blurModel() { //型号验证
      let val = $.trim(this.fromCargoInfo.prodModel)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (val && val.length > 50) {
        this.fromCargoInfo.msgModel = 'Maximum is 50 characters'
        return false
      } else if (val && !regTest.test(val)) {
        this.fromCargoInfo.msgModel = 'English only'
        return false
      } else {
        this.fromCargoInfo.msgModel = ''
        return true
      }
    },
    blurSpec() { //规格验证
      let val = $.trim(this.fromCargoInfo.prodSpeci)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (val && val.length > 50) {
        this.fromCargoInfo.msgSpeci = 'Maximum is 50 characters'
        return false
      } else if (val && !regTest.test(val)) {
        this.fromCargoInfo.msgSpeci = 'English only'
        return false
      } else {
        this.fromCargoInfo.msgSpeci = ''
        return true
      }

    },
    blurBrand() { //品牌验证
      let val = $.trim(this.fromCargoInfo.prodBrand)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (!val) {
        this.fromCargoInfo.msgBrand = 'Required'
      } else if (val.length > 50) {
        this.fromCargoInfo.msgBrand = 'Maximum is 50 characters'
        return false
      } else if (!regTest.test(val)) {
        this.fromCargoInfo.msgBrand = 'English only'
        return false
      } else {
        this.fromCargoInfo.msgBrand = ''
        return true
      }
    },
    blurColor() { //颜色验证
      let val = $.trim(this.fromCargoInfo.prodColor)
      let regTest = /^[^\u4E00-\u9FA5]+$/
      if (val && val.length > 50) {
        this.fromCargoInfo.msgColor = 'Maximum is 50 characters'
        return false
      } else if (val && !regTest.test(val)) {
        this.fromCargoInfo.msgColor = 'English only'
        return false
      } else {
        this.fromCargoInfo.msgColor = ''
        return true
      }
    },
    //产品信息库中弹框确定按钮
    proConfirmBtn() {
      if (!this.blurReq() || !this.blurCusCode() || !this.blurMaterial() || !this.blurUse() || !this.blurModel()
        || !this.blurSpec() || !this.blurBrand() || !this.blurColor()
      ) {
        return false
      }
      if (this.fromCargoInfo.Id) {
        this.editPortInfo();
      } else {
        this.addPortInfo();
      }
    },


  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/myInfo/myInvoice.js